import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/service/measurement-helper.ts' );

import {Injectable} from '@angular/core';
import {FeatureCollection, Features, Geometry} from '../main/map/detail-views/annots/FeatureCollection';
import {debounceTime, tap} from 'rxjs/operators';
import { Subscription, forkJoin, of as observableOf } from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {MapService} from '../commons/map.service';
import {EntityHelperService} from '../service/entity-helper.service';
import {Annotation, Transform} from '4d-mapper';
import {Constants} from '../commons/Constants';
import { AnnotationType } from '../commons/global';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';


const Cesium = (<any>window).Cesium;


// future refactor is using this class as the basis for storing and serialising Shape data

// Coord, as a standard object for Cesium Cartesian3 objects
export class Coord {
  x:number = null;
  y:number = null;
  z:number = null;
}

/* note: AnnotationShapes and Shape classes are not used yet, it's the next iteration of refactorings we need to do */

export class AnnotationShapes {

  id: string = null;
  annotationRef: number = null;
  entityRef: string = null;

  selectedShape:string = null;

  calc: { totalLength:0, totalArea:0, totalVolume:0, midPoint:null }

  shapes: Shape[] = null;

  constructor ( incoming:any[] = null ) {
    if ( ! incoming ) {
      console.error ( '%c No incoming shapes', Constants._yellow );
    }
    this.load ( incoming );
  }
  load ( incoming:any ) {
    // load and set up all shapes
  }
}

export class Shape {
    id: string = null;
    entityRef: string = null;
    selectedPoint:string = null;
    points: any[] = null;
}


@Injectable({
  providedIn: 'root'
})
export class MeasurementHelperService implements XsIdentityInterface {

  __ID = null;

  debug:boolean = Constants.debug_off;

  // stylished debug info
  private debugStyle:string = 'color:red;background-color:#ccc;';

  // last checked mouse position
  lastMousePosition:any = null;

  // last incoming mouse event movement object (Cesium or Angular)
  lastMovement:any = null;

  // current cartesian picked position of mouse poisition
  pickedCartesian:any = null;

  // picked world coordinate
  pickedCoord:any = null;

  // all models found under mouse position
  pickedModels:any = null;

  // top model found
  pickedModel:any = null;

  cached:any = null;

  // reusable temporary catrographic object
  tempCartographic = new Cesium.Cartographic();

  private number_precission:number = 2;

  showDebug:boolean = false;
  showPickingMatrix:boolean = false;
  doDrillPick:boolean = false;

  pickingMethod:string = 'standard'; // vs. 'ray'
  pickingMatrix:string = 'standard'; // vs. 'custom'
  customMatrixSize:number = 2;

  // are we picking pointclouds?
  pickingPointclouds:boolean = false;

  // are we picking transparent objects?
  pickingTransparent:boolean = false;

  // are we picking on a transparent terrain?
  pickingTransparentTerrain:boolean = false;

  transparentPickGlobe:boolean = false;

  // all picked positions
  pickedMatrix:any = [];

  debugProps:any = [];
  debugPickingTime:number = 0;
  debugLastThreePicks:string = null;

  haveSetupHandler:boolean = false;
  preRenderListener:any = null;



  countRender:number = 0;
  countMouseAction:number = 0;
  countMouseCalls:number = 0;

  // cached picked position and list of drillPicked items
  cachedPosition:any = null;
  cachedItems:any = null;


  constructor(private httpClient: HttpClient, public mapService: MapService, public entityHelper: EntityHelperService ) {
    DEBUG.log ( '/service/measurement-helper.service.ts' );
    this.__ID = XsIdentityInterface.__init(this);
  }

  setup() {
    let me = this;
    this.preRenderListener = this.mapService.viewer.scene.preUpdate.addEventListener(function (scene) {
      me.countRender++;
  });
  }

  // this function does a Cesium viewer.scene.drillPick() operation on mouse coordinates, and return recognised
  // objects (ie. handles, shapes, tilesets, etc.)

  checkMousePosition ( move = null, cached:boolean = false ) {

    if ( ! this.haveSetupHandler ) {
      this.haveSetupHandler = true;
      this.setup();
    }

    this.countMouseCalls++;

    // some just want the cached object
    if ( cached && this.cached ) {
      return this.cached;
    }

    this.countMouseAction++;

    // incoming movement
    if ( move ) {

      // local copy
      this.lastMovement = move;

      // if incoming movement is a Cesium one
      if ( move.endPosition ) {
        this.lastMovement.position = move.endPosition;
      }

      // update the last known mouse position
      this.lastMousePosition = this.lastMovement.position ;
    }
    
    // define up all that we return
    let ret = {
      type: null, feature: null, tileset: null,
      handle: null, action: null, plugin: null,
      transform: null, transformId: null, new: null,
      vertical_offset: 0, coords: null, props:null,annotationId:null,
      currentCoord: { position:null, positionCart:null, positionRadians:null, positionRadiansP:null, screenPoint:this.lastMousePosition, screenHeight:null, entity:null },
      debug: { movement: move, objs: null, obj:null, type: null }
    };

    

    // create a cartesian position object from our position coords
    ret.coords = this.pickPositionSnapToTileset ( this.lastMousePosition );

    // the coords sub-object is for backwards compatibility with a ton of shitty Haresh code ...
    if (ret.coords) {
      ret = this.updateCurrentCoord ( ret );
    }

    ret.debug.objs = this.pickedModels;
    ret.debug.obj = this.pickedModel;

    if ( ! this.pickedModels ) {

      // no entities or models found
      this.cached = ret;
      return ret;
    }

    // is this item linked to a plugin?
    const plugin = this.pickedModels.find(f => f.id && ( ( f.id['__type'] && f.id.__type === 'pluginref' ) || ( f.id['_type'] && f.id._type === 'pluginref' ) ) );

    if (Cesium.defined(plugin) && plugin.id) {

      ret.plugin = plugin.id;
      ret.type = 'pluginref';

      if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found PLUGIN', ret); }
      
      this.cached = ret;
      return ret;
    }


    // is this an action handle we found?
    const action = this.pickedModels.find(f => f.id && f.id['__type'] &&  ( f.id.__type === 'addhandle' ||  f.id.__type === 'deletehandle' ) );

    if (Cesium.defined(action) && action.id) {

      ret.action = action.id;
      ret.props = this.entityHelper.getEntityProperties ( ret.action.id );

      ret.type = ret.action.constructor.name;
      if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found ADD/DELETE HANDLE', ret); }

      this.cached = ret;
      return ret;
    }

    
    // is this a handle we found?
    const handle = this.pickedModels.find(f => f.id && f.id['__type'] && f.id.__type === 'handle');

    if (Cesium.defined(handle) && handle.id) {

      ret.handle = handle.id;
      ret.props = this.entityHelper.getEntityProperties ( ret.handle.id );

      ret.type = ret.handle.constructor.name;
      if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found HANDLE', ret); }
      
      this.cached = ret;
      return ret;
    }


    // or maybe a feature?
    const feature = this.pickedModels.find(f => f.id && f.id.__type !== 'ghostline' );

    if ( Cesium.defined(feature) && feature.id ) {

      ret.feature = feature.id;
      ret.props = this.entityHelper.getEntityProperties ( ret.feature.id );

      if ( ret.feature['_transformId'] ) {
        ret.transformId = ret.feature['_transformId'];
      }

      if ( ret.feature['_annotationId'] ) {
        ret.annotationId = ret.feature['_annotationId'];
      }

      ret.type = ret.feature.constructor.name;
      if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found FEATURE', ret, this.entityHelper.entity_properties ); }

      this.cached = ret;
      return ret;
    }


    // or maybe a tileset?
    const tileset = this.pickedModels.find(f => f.content);

    if (Cesium.defined(tileset) && tileset.content ) { // && tileset.content._tileset.id

      if ( move['position'] ) { ret.transform = this.mapService.helper.resolveItem(move); }
      ret.tileset = tileset;
      ret.type = ret.tileset.constructor.name;

      // if it's a Transform as well, it might have a vertical offset
      if ( ret.transform && ret.transform.vertical_offset ) {
        ret.vertical_offset = ret.transform.vertical_offset;
      }

      if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found TILESET', ret); }

      this.cached = ret;
      return ret;
    }


    if ( this.debug ) { console.log ( ' -- mappingHelper :: checkMousePosition() found NOTHING', ret); }

    this.cached = ret;
    return ret;
  }

  dup ( n ) {
    let str = JSON.stringify( n );
    let par = JSON.parse(str);
    if ( this.debug ) { console.log ( 'mappingHelper :: dup()', n, str, par ); }
    return par;
  }

  updateCurrentCoord ( ret:any ) {

    // const radians = Cesium.Cartographic.fromCartesian(ret.coords);
    // const pos = Cesium.Cartographic.fromDegrees ( radians.longitude * 180 / Math.PI, radians.latitude * 180 / Math.PI, radians.height );
    // const p = { longitude: radians.longitude * 180 / Math.PI, latitude: radians.latitude * 180 / Math.PI, height: radians.height };
    
    ret.currentCoord.position = Cesium.Cartographic.fromCartesian(ret.coords);
    ret.currentCoord.positionCart = ret.coords;
    // ret.currentCoord.positionRadians = radians;
    // ret.currentCoord.positionRadiansP = p;
    ret.currentCoord.screenHeight = this.mapService.viewer.canvas.heigh;

    // console.log('## measure update_coord',ret);

    return ret;
  }

  // find outliers of z values
  /*
  filterOutliers (zArray) {

    let values = zArray.slice().sort((a, b) => a - b);

    let q1 = this.getQuantile(values, 25);
    let q3 = this.getQuantile(values, 75);

    let iqr, maxValue, minValue;
    iqr = q3 - q1;
    maxValue = q3 + iqr * 1.5;
    minValue = q1 - iqr * 1.5;

      return( values.filter((z) => (z >= minValue) && (z <= maxValue)));

  }

  getQuantile (array, quantile) {

    let index = quantile / 100.0 * (array.length - 1);

    if (index % 1 === 0) {
        return array[index];
    } else {
        let lowerIndex = Math.floor(index);
        let remainder = index - lowerIndex;
        return array[lowerIndex] + remainder * (array[lowerIndex + 1] - array[lowerIndex]);
    }
  }
*/
  getCartographicFromCartesian ( p = null ) {
    if ( p && p['x'] ) {
      let test = Cesium.Cartographic.fromCartesian( p );
      if ( test ) {
        return test;
      }
    }
    return null;
  }
  getHeightFromCartographic ( ca ) {
    let h:number = null;
    if ( ca ) {
      h = this.roundTo(ca.height);
      //h = Math.round(ca.height);
    }
    return h;
  }

  roundTo(n:number) : number {

    if ( isNaN(n) ) {
      return 0;
    }

    return Math.ceil(n * 100)/100;

    // return Number.parseFloat(n).toFixed(2);

    // return n.toPrecision(2);

    /* refactor
    var negative = false;
    if (digits === undefined) {
        digits = 0;
    }
    if (n < 0) {
        negative = true;
        n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);
    if (negative) {
        n = (n * -1).toFixed(digits);
    }
    return n;
    */
}

  pickRay  ( incoming_position:any ) {
    let rayScratch = this.mapService.viewer.scene.camera.getPickRay(incoming_position);
    this.pickingMethod = 'ray';
    return this.mapService.viewer.scene.globe.pick(rayScratch, this.mapService.viewer.scene);
  }

  pickPosition ( incoming_position:any, checkTrans:boolean = true, justRay:boolean = false ) {

    let pickRay:boolean = this.pickingTransparentTerrain && checkTrans;
    
    if ( justRay ) { pickRay = true; }

    if ( pickRay ) {
      return this.pickRay ( incoming_position ); 
    }
    if ( this.transparentPickGlobe ) {
      this.pickingMethod = 'ellipsoid';
      return this.mapService.viewer.camera.pickEllipsoid(incoming_position);
    }
    this.pickingMethod = 'standard';
    return this.mapService.viewer.scene.pickPosition(incoming_position);
  }

  // sandcastles of trying to figure out a better picker system
  // https://sandcastle.cesium.com/#c=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
  // https://sandcastle.cesium.com/#c=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
  
  pickPositionSnapToTileset ( incoming_position:any ) {

    // console.log('.',incoming_position);
    if ( ! incoming_position || ! incoming_position.x || ! incoming_position.y ) {
      return;
    }

    let startTime = performance.now();

    this.pickedMatrix = [];

    // this.transparentPickGlobe = !this.pickingTransparentTerrain;

    // quick model pick first seems to stabilise pickPosition() heights
    this.pickedModel = this.mapService.viewer.scene.pick(incoming_position);

    /* this.pickedModels = this.mapService.viewer.scene.drillPick(incoming_position, 4, 4, 4);
    if ( this.pickedModels ) {
      this.pickedModel = this.pickedModels[0];
    } else {
      this.pickedModel = null;
    } */

    if ( this.pickedModel ) {
      this.transparentPickGlobe = false;
    } else {
      this.transparentPickGlobe = this.pickingTransparentTerrain;
    }

    let pickFromPointcloud = false;
    if ( this.pickingPointclouds || this.lastMovement['forceFullResolution'] ) {
      pickFromPointcloud = true;
    }

    const offsetX = incoming_position.x;
    const offsetY = incoming_position.y;

    // the default matrix are all the points we're checking (order is important; we do a modulus 2 picking when globe is transparent)
    let matrix = [ [0,0], [-4,-6], [4,3], [-1,-2], [2,-1], [1,0], [0,1], [-2,0], [2,0], [-6,0], [-8,0], [6,0], [8,0] ];

    if ( !pickFromPointcloud ) {
      matrix = [ [0,0] ];
    }

    // if we want a custom matrix
    if ( this.pickingMatrix == 'custom' ) {
      matrix = []; // reset matrix
      let half = Math.round(this.customMatrixSize / 2);
      let lower = 0-half;
      for (var i=lower;i<this.customMatrixSize;i+=1){
        for (var j=lower;j<this.customMatrixSize;j+=1){
          matrix.push( [i,j] );
        }
      }
    }

    let minx = 9999;
    let miny = 9999;
    matrix.forEach ( p => {
      if ( p[0] < minx ) { minx = p[0]; }
      if ( p[1] < miny ) { miny = p[1]; }
    });

    minx = Math.abs(minx);
    miny = Math.abs(miny);

    let findmax = -9999;

    // how many meters change before we reset
    let threshold = 10;

    let finished:boolean = false;
    let ret = null;
    let retCoord = null;

    // looking for three height readings in a row
    let height_1:number = null;
    let height_2:number = null;
    let height_3:number = null;

    let counter = 0;

    // start checking positions
    matrix.forEach ( test => {

      counter++;

      let x = test[0];
      let y = test[1];
      let cart2 = new Cesium.Cartesian2 ( offsetX - x, offsetY + y );

      if ( ! finished ) {

        // let's pick! (but not for transparent terrains after the first 6 picks)
        let pick = this.pickPosition(cart2, counter % 2 ? true : false );
        let cart3 = this.getCartographicFromCartesian(pick);

        // note: heights here are rounded
        let current_height = this.getHeightFromCartographic(cart3);

        if ( current_height !== null ) {

          let jump = this.roundTo(current_height - findmax);
          if ( current_height > findmax ) { findmax = current_height; }
          
          if ( !pickFromPointcloud ) {

            // no pointclouds means we can just exit with the current pick
            
            finished = true;
            ret = pick;
            retCoord = cart3;
            this.debugLastThreePicks = null;

          } else {

            // we only care if we're jumping forwards
            if ( jump >= 0 && Math.abs(jump) > threshold ) {

              // if we've jumped ahead more than the threshold, reset all
              height_1 = height_2 = height_3 = null; 
            }

            if ( current_height >= findmax - threshold && current_height <= findmax + threshold ) {
              if ( ! height_1 ) {  height_1 = current_height; } 
              else if ( ! height_2 ) { height_2 = current_height; }
              else if ( ! height_3 ) { height_3 = current_height; }
            }

            // if ( this.showDebug ) { 
              this.debugLastThreePicks = current_height +'m : '+height_1+'m,'+height_2+'m,'+height_3+'m'+' -- '+(findmax-threshold)+'/'+(findmax+threshold); 
            // }
              
            // only after we've got three samples
            if ( height_1 && height_2 && height_3 ) {

              let test1 = Math.abs ( height_1 - height_2 );
              let test2 = Math.abs ( height_2 - height_3 );

              // found three in a row with less than 5m height difference
              if ( current_height && ( test1 < 5 && test2 < 5 ) ) {
                finished = true;
                ret = pick;
                retCoord = cart3;
                if ( retCoord ) {
                  retCoord.height = test1<5 ? height_1 : height_3;
                }
              }

            }
          }

          if ( this.showDebug ) { this.pickedMatrix.push ({ 
            idx:counter, pos:{x:minx+x,y:miny+y}, coord:cart2, pick:pick, height:current_height, 
            jump:jump, jumpabs:Math.abs(jump), jumpafter:this.roundTo(current_height-findmax), max:findmax, 
            height1:height_1,height2:height_2,height3:height_3, test: jump > 0 && Math.abs(jump) > threshold,
            inRange: current_height >= findmax - threshold && current_height <= findmax + threshold
          }); }

        }

      } else {
        if ( this.showDebug ) { this.pickedMatrix.push ({ pos:{x:minx+x,y:miny+y}, coord:cart2, jump:-1, height:-1 }); }
      }

    });

    this.pickedModels = this.mapService.viewer.scene.drillPick(incoming_position, 4, 4, 4);

    // this.mapService.viewer.render();
    // this.pickedModel = this.mapService.viewer.scene.pick(incoming_position);
    
    // if ( ! this.pickedModel ) { this.pickedModel = this.pickedModels[0] ? this.pickedModels[0] : false; }

    if ( ret ) {
      this.pickedCartesian = ret;
    }
    if ( retCoord ) {
      retCoord.longitude = retCoord.longitude * 180 / Math.PI;
      retCoord.latitude = retCoord.latitude * 180 / Math.PI;
      // if ( this.pickedModel && this.pickedModel[''] ) {
      //   if ( this.mapService.sceneTransforms)
      // }
      this.pickedCoord = retCoord;
    }

    this.debugPickingTime = Math.round( performance.now() - startTime );

    if ( this.lastMovement.forceFullResolution ) {
      this.lastMovement.debug = { lastThree: this.debugLastThreePicks, matrix: matrix };
      this.lastMovement.forceFullResolution = false;
    }

    return ret;    
  }

  sampleHeight ( coords:any ) {

    // let coord = new CoordGeodetic( coords );
    let cesiumCoord = coords; // .toCesiumCartographic();

    let s = this.mapService.viewer.scene.sampleHeight(cesiumCoord);
    let g = this.mapService.viewer.scene.globe.getHeight(cesiumCoord);

    return { coord:cesiumCoord, s:s, g:g };

/*
    var positions = [ cesiumCoord ];
    var promise = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, positions ); 

    // console.log('*****', positions, promise, this.mapService.viewer.terrainProvider );

    Cesium.when(promise, function(updatedPositions) { 
      // console.log('*****!!!!!!', updatedPositions);
      if ( updatedPositions && updatedPositions[0] ) {
        return { type:'promise', data:updatedPositions[0] };
      }
    }); 
    return null;
*/
  }

    // this.pickedCartesian = this.pickPosition ( incoming_position );

    
    //if ( this.mapService.viewer.scene.globe.translucency.enabled && ! this.pickedModel ) {

      // this.pickedCartesian = this.pickRay ( incoming_position );
     // state = 'ray';
        
    
        /* let carto = null;
        if ( scratchDropConversion ) {
          carto = Cesium.Cartographic.fromCartesian( scratchDropConversion );
          carto.longitude = carto.longitude * 180 / Math.PI;
          carto.latitude = carto.latitude * 180 / Math.PI;
          // carto.height = carto.height - this.vertical_offset;
        }
        console.log('$$$$ tryPicking()', carto ); */
      // this.pickedCartesian = this.mapService.viewer.camera.pickEllipsoid(incoming_position);
    //}
/*
    let carto = null;
    if ( this.pickedCartesian ) {
      carto = Cesium.Cartographic.fromCartesian( this.pickedCartesian );
      carto.longitude = carto.longitude * 180 / Math.PI;
      carto.latitude = carto.latitude * 180 / Math.PI;
    }
*/
    // console.log ( "$$$", this.pickedModel );

    /*

      disabled for now; there's complications as this function is used by different places in different ways, so the
      new tests screws up behaviour in some parts;

       * it lowers the precision of coord picking for pointclouds, which is why we made this to begin with
       * the lag in cursors comes from this
       * setting precise coords in pins is lost
       * hitting first-time clicks are lost

      Instead of tinkering with these tests here, let's document where
      the issues are first, and see if we can solve them from there.

      //run this function if transform is pointcloud only
      let model=this.mapService.viewer.scene.pick(incoming_position);

      if (model && model.primitive instanceof Cesium.Billboard)
        return; // if annotation tags is picked

  */


    //if not pointcloud return the coordinates without running the filter
    /*
    if (!this.pickedModel || !this.pickedModel.content || !(this.pickedModel.content instanceof Cesium.PointCloud3DTileContent)) {
      console.log('.', carto, state);
      return this.createPosition(incoming_position);
    }
*/


    // let anyPointClouds:boolean = false;


  


/*


    //let final = {};
    let nm = [];
    let max = -9999;
    let maxIdx = null;
    let pickEllipsoid = null;
    //let cc = 0;
    let ret = null;

    // size=5, half=2
    let half = Math.round(this.matrixSize / 2);
    let lower = 0-half;

    for (var i=lower;i<this.matrixSize;i+=1){
      let row = [];
      for (var j=lower;j<this.matrixSize;j+=1){
        const pos = new Cesium.Cartesian2 ( offsetX - i, offsetY + j );
        const p = this.pickPosition(pos);
        let h = -1;
        if ( p ) {
          const ca = Cesium.Cartographic.fromCartesian( p );
          //final[cc] = ca;
          if ( ca ) {
            h = Math.round(ca.height);
            if ( h > max ) {
              max = h;
              ret = ca;
            }
          }
        }
        row.push(h);
        matrix.push([i,j]);
      }
      nm.push(row);
    }

    this.debugProps['matrix'] = nm;

    if ( this.doDrillPick ) {
      this.pickedModels = this.mapService.viewer.scene.drillPick(incoming_position, 4, 13, 13);
      this.pickedModel = this.pickedModels[0] ? this.pickedModels[0] : null;
    }
    
    this.debugPickingTime = Math.round( performance.now() - startTime );

    return ret;

    // positions, the z index, and first/original position
    let positions = [];
    let zArray = [];
    //let original = null;

    let count = 0;
    // let max = 0;

    state = 'cluster';


    // let's give this a few goes
    for ( count=0; count<matrix.length; count++ ) {

      // OK, let's try this coordinate
      const pos = new Cesium.Cartesian2 ( offsetX - matrix[count][0], offsetY + matrix[count][1] );

      // pick a position
      const p = this.mapService.viewer.scene.pickPosition(pos);
      // const p = this.pickRay (pos);

      /*
      let h = -1;
      if ( p ) {
        const ca = Cesium.Cartographic.fromCartesian( p );
        if ( ca ) {
          h = ca.height;
        }
      }

      nm.push([])

      // only legit positions welcome
      if ( p && p.z ) {

        positions.push(p);
        zArray.push(p.z);

      }
    };

    this.debugProps['matrix'] = nm;

    // let's give this a few goes
    for ( count=0; count<matrix.length; count++ ) {

      // OK, let's try this coordinate
      const pos = new Cesium.Cartesian2 ( offsetX - ( x / 2 ) + matrix[count][0], offsetY - ( y / 2 ) + matrix[count][1] );

      // pick a position
      const p = this.pickRay (pos); // this.mapService.viewer.scene.pickPosition(pos);

      // only legit positions welcome
      if ( p && p.z ) {

        positions.push(p);
        zArray.push(p.z);

        // keep a copy of the first / original try
        if ( ! original ) {
          original = p;
        }
      }
    };

    // filter z coordinates
    let filtered = this.filterOutliers(zArray);

    let returnedIndex = -1;

    //find the filterd array index
    for ( var n = 0; n < zArray.length; ++n) {
      for ( var m = 0; m < filtered.length; ++m) {
        if (zArray[n]===filtered[m]){
          returnedIndex=n;
          break;
        }
        if (returnedIndex!==-1){ state = 'cluster-found'; break; }
      }
    }

    if (returnedIndex !== -1) {
      let heights = '';
      positions.forEach( p=> {
        if ( p ) {
          const ca = Cesium.Cartographic.fromCartesian( p );
          if ( ca ) {
            ca.longitude = ca.longitude * 180 / Math.PI;
            ca.latitude = ca.latitude * 180 / Math.PI;
            if ( ca.height > max ) {
              max = ca.height;
            }
            // heights = heights + ca.height + 'm ';
          }
          
        }
      });
      state = 'cluster-found='+max+' ('+positions.length+')';
    }

    // this.pickedCartesian = this.pickRay ( incoming_position );

    // console.log ( 'incoming', offsetX, offsetY, poss);
    // console.log("z arrays, returnedIndex", positions, zArray, filtered, returnedIndex, positions[returnedIndex] ? positions[returnedIndex] : null );
    // console.log ( '@@', this.mapService.viewer.scene.pickPosition({x:offsetX,y:offsetY}), this.mapService.viewer.scene.pickPosition({x:offsetX + 10,y:offsetY + 10}) );

    // if ( returnedIndex !== -1 ) {
    //   carto = Cesium.Cartographic.fromCartesian( positions[returnedIndex] );
    //   carto.longitude = carto.longitude * 180 / Math.PI;
    //   carto.latitude = carto.latitude * 180 / Math.PI;
      //console.log('.',state, carto.height );
    // } else {
      //console.log('. !!!',state, max );
    // }

    

    if (returnedIndex===-1) { // if nothing filterd out use the first array coordinates
        return this.pickedCartesian;
    }

    return positions[returnedIndex];
    */
  



  createPosition (pos:any) {
  /*[Adam]pickPosition can be null sometimes, try other pick options if it is null to avoid clicks being rejected on map
  Specially when this comes from pickPositionSnapToTileset function it means either there were no pointclouds found
  or the '+' cursor billboard icon was picked instead of the pointcloud, I did quite a bit of testing and seems like cesium pickPosition
  is not capable of getting the depth buffer from GPU correctly if a billboard is preset. So commented out the '+' cursor billboard and added these new tests
  to return picked position.
  */

    // let eoords = this.mapService.viewer.camera.pickEllipsoid(pos);
    // let coords = this.mapService.viewer.scene.pickPosition(pos);
    // let diff = (eoords.x ? eoords.x : 0 - coords.x ? coords.x : 0 ) + (eoords.y ? eoords.y : 0 - coords.y ? coords.y : 0 ) + (eoords.z ? eoords.z : 0 - coords.z ? coords.z : 0 );
    // console.log('!',diff);  


  if (!this.pickedCartesian){
  //why? a hickup in cesium depth filter, try the nearby screen pixel position
  pos.x+=1;
  pos.y+=1;
  this.pickedCartesian=this.mapService.viewer.scene.pickPosition(pos);
  }
  if(!this.pickedCartesian){ //if still null try another method,this works well for terrain
    var ray = this.mapService.viewer.camera.getPickRay(pos);
    this.pickedCartesian = this.mapService.viewer.scene.globe.pick(ray, this.mapService.viewer.scene);
    }
  if (!this.pickedCartesian){ //still nothing, so no terrain, try picking on ellipsoid
  var ellipsoid = this.mapService.viewer.scene.globe.ellipsoid;
  this.pickedCartesian = this.mapService.viewer.camera.pickEllipsoid(pos, ellipsoid);
  }

    return this.pickedCartesian;
  }


  /*
      An Annotation shape is the Cesium entity you see on the map (lines, polygons, etc.)
  */

  createAnnotationShapes ( a:Annotation ) {

    // this.debug = true;

    let type = a['annotationMode'];

    const debugStyle = 'color:white;background-color:orange;';
    if ( this.debug ) { console.log ( '%c measurement-helper :: createAnnotationShapes() "'+a.name+'" ['+a.id+']', debugStyle, type, a['shapes'], a ); }

    // Pin?
    if ( type === AnnotationType.poi ) {

      let e = this.mapService.helper.setPlottable(a, { entity: { type: 'poi', __type: 'poi' } } );
      const tmp = e.subscribe( p => {
        if ( p ) {
          let pin = p.object.pin;
          pin['type'] = 'poi';
          pin['__type'] = 'poi';
          pin['__abc'] = 'm-h.s:pin='+a.id;
          if ( this.debug ) { console.log ( '%c measurement-helper :: createAnnotationShapes() "'+a.name+' UPDATING PIN" ['+a.id+']', debugStyle, type, p, pin ); }
        }
      });

      if ( this.debug ) { console.log ( '%c measurement-helper :: createAnnotationShapes() "'+a.name+' RETURNING PIN" ['+a.id+']', debugStyle, type, e ); }
      // this.debug = false;

      // Already supported by the CesiumHelper (but we inject the 'type' property)
      return e;

    // these are the shapes we need to go through (is there, is an array, and has items in it)
    } else {

      if ( a['shapes'] ) {

        // for each shape
        a['shapes'].forEach ( function (current_shape,idx) {

          // shape has 2 or more points?
          if ( current_shape.points && current_shape.points.length > 0 ) {
            this.createAnnotationShape ( a, idx, current_shape );
          } else {
            if ( this.debug ) { console.error ( 'MeasureHelper :: CreateAnnotationShapes = ['+type+'] wanted, but not enough points', a); }
          }
        }, this ) ; // remember 'this' to avoid this spaghetti
      }

      if ( this.debug ) { console.log ( '%c measurement-helper :: createAnnotationShapes() "'+a.name+' RETURNING OTHER" ['+a.id+']', debugStyle, type ); }

      // this.debug = false;

      return observableOf(null);
    }
  }

  createAnnotationShape ( a:Annotation, idx, current_shape ) {

    let type = a['annotationMode'];
    let annotationRef = a ? ( a['id'] ? a['id'] : 0 ) : null;

    // line/shape properties
    let props = {
      shapeRef: idx,
      annotationRef: annotationRef,
      positions: current_shape.positions,
      // callback: current_shape['positionsCallback'].bind(this),
      // positions: new Cesium.CallbackProperty(current_shape.positionsCallback.bind(current_shape.positionsCallbackThis),false),
      lineWidth: current_shape['lineWidth'],
      color: Cesium.Color.fromCssColorString ( current_shape['color'] ),
      colorAlpha: 1,
      perPositionHeight: ! current_shape['clamping'],
      clampToGround: current_shape['clamping']
    };

    if ( current_shape['positionsCallback'] ) {
      props['positions'] = new Cesium.CallbackProperty( current_shape.positionsCallback.bind(current_shape.positionsCallbackThis), false); // new Cesium.CallbackProperty(current_shape.positionsCallback,false);
    }
    else if ( current_shape['points'] && current_shape['points'] instanceof Array && current_shape['points'].length > 0 ) {
      props['positions'] = current_shape['points'].map(p => { if ( p && p.coords ) return p.coords; });
    }

    

    if ( this.debug ) { console.log ( '%c measurement-helper.service %c createAnnotationShape()', Constants._red, Constants._red, props, a, idx, current_shape ); }


    let _obj = this.entityHelper.addEntity( type, props, a, 'measure-helper-' + annotationRef );
    if ( _obj ) {
      if ( this.debug ) { console.log ( '%c createAnnotationShape CREATED', this.debugStyle, idx, a['shapes'], current_shape, props, _obj); }
      if ( a['shapes'][idx] ) a['shapes'][idx]['entityRef'] = _obj;
      current_shape.entityRef = _obj;
      return _obj;
    }
    if ( this.debug ) { console.log ( '%c createAnnotationShape FAILED', this.debugStyle, current_shape, props, _obj); }
    if ( a['shapes'][idx] ) a['shapes'][idx]['entityRef'] = null;
    current_shape.entityRef = null;
    return null;
  }

  deleteAnnotationShapes ( a:Annotation ) {
    let annotationRef = a ? ( a['id'] ? a['id'] : 0 ) : null;
    let type = a['annotationMode'];
    let _deleted = [];

    if ( type === AnnotationType.poi ) {
      this.mapService.helper.removePlottable(a);
    } else {
      this.entityHelper.destroyEntitiesByCaller ( 'measure-helper-' + annotationRef );
    }

    if ( this.debug ) { console.log ( '%c deleteAnnotationShapes', this.debugStyle, type, _deleted, a); }
  }

  // convert old format (found in Annotation['points']) to the new
  convertFromOldFormat ( a: Annotation ) {

    // our final shape object
    let shapes = [];

    // type of annotation
    let type = a['annotationMode'];

    const debugStyle = 'color:white;background-color:green;';

    // Pin?
    if ( type === AnnotationType.poi ) {
        // No shape support (we use addPlottable() for these for now)

    // All else?
    } else {

        // Has it got shapes? [Note: 'points' is a misnomer, and need some refactoring/renaming in the future]
        if (a['points']) {

            // for each shape
            for (let shape = 0; shape < a['points'].length; shape++) {

                let current_shape = {
                    annotationRef: a.id,
                    oldPositionRef: shape
                };

                let shapes_with_points = [];

                // Go through all points (if exists)
                a['points'][shape].forEach( point => {

                    // index of entities for this shape
                    if ( point && point['coords'] ) {
                      shapes_with_points.push( true );
                    } else {
                      // console.log ( ' - no conversion of NULL point', a.id, a['points'][shape], shape, point );
                    }

                });

                // any points in the shape? Then add it to our index
                if ( shapes_with_points.length > 1 ) {

                    // defaults
                    if ( ! current_shape['color'] ) {
                        current_shape['color'] = this.getOldFormatShapeProperty('currentColor', shape, a, '#0ff000' );
                    }
                    if ( ! current_shape['lineColor'] ) {
                        current_shape['lineColor'] = this.getOldFormatShapeProperty('currentColor', shape, a, '#00ff00' );
                    }
                    if ( ! current_shape['lineWidth'] ) {
                        current_shape['lineWidth'] = 5;
                    }
                    if ( ! current_shape['clamping'] ) {
                        current_shape['clamping'] = this.getOldFormatShapeProperty('clampToModel', shape, a, false );
                    }
                    if ( ! current_shape['shapeInfo'] ) {
                        current_shape['shapeInfo'] = this.getOldFormatShapeProperty('showLineInfo', shape, a, true );
                    }

                    // default/first shape should open their options by default
                    if ( shape == 0 ) {
                        current_shape['showOptions'] = true;
                    }

                    // transfer in the points
                    current_shape['points'] = a['points'][shape];

                    shapes.push ( current_shape );
                }
            }
        }
    }

    if ( this.debug ) { console.log ( '%c convertFromOldFormat "'+a.name+'" ['+a.id+']', debugStyle, a, shapes); }

    return shapes;

  }

  getOldFormatShapeProperty ( p:string, shape:number, a:Annotation, _default:any ) {
    let ret = _default;
    let ps = a['pointsProps'];
    if ( ps ) {
      let s = ps[shape];
      if ( s ) {
        let find = s.findIndex(e => e[p]);
        let test = find !== -1 ? s[find][p] : false;
        if ( test ) {
          ret = test;
        }
      }
    }
    return ret;
  }

  // quick validator for the Shapes object
  testFormat ( shapes ) {
    let valid = true;
    for ( let n=0; n<shapes.length; n++ ) {
      if ( shapes[n] ) {
        let shape = shapes[n];
        // console.log ( 'testingFormat() shape', shape);
        for ( let p=0; p<shape.points.length; p++ ) {
          let point = shape.points[p];
          // console.log ( 'testingFormat() point', point);
          if ( ! point || ! point['coords'] ) {
            valid = false;
          } else {
            if ( ! point['coords'] || ! point.coords['x'] || ! point.coords['y'] || ! point.coords['z'] ) {
              valid = false;
            }
          }
        }
      } else {
        valid = false;
      }
    }
    return valid;
  }

// we need to convert all Cartesian3 coordinates to standard objects before saving
  prepareForSerialising ( shapes ) {
    // console.log ( 'prepFormat()', shapes );
    for ( let n=0; n<shapes.length; n++ ) {
      if ( shapes[n] ) {
        let shape = shapes[n];

        // remove these if they exist
        if ( shape['positionsCallback'] ) {
          delete shape['positionsCallback'];
        }
        if ( shape['positionsCallbackThis'] ) {
          delete shape['positionsCallbackThis'];
        }
        
        for ( let p=0; p<shape.points.length; p++ ) {
          let point = shape.points[p];
          if ( point && point['coords'] ) {
            let coords = point['coords'];
            //if ( coords.constructor.name == 'Cartesian3' ) {
              shapes[n].points[p].coords = { x: coords.x, y: coords.y, z: coords.z };
            //}
          }
        }
      }
    }
    // console.log ( 'prepFormat() DONE', shapes );
    return shapes;
  }


  /*
      Handy calculators for measuring stuff, mostly point-to-point
  */

  realNumber (x) {
    return Number.parseFloat(x).toFixed( this.number_precission );
  }

  // returns a value converted to the users localised units (metric vs. imperial vs. other)
  public getLocalisedValue ( value: any, a:Annotation = null ) {

    if ( a && a.project && a.project['number_precission'] ) {
      this.number_precission = a.project['number_precission'];
    }

    const feetValue = 0.3048;
    var units = MapService.METER;
    var sign = ' m';

    if ( a && a.project && a.project['measurementUnit'] ) {
      units = a.project['measurementUnit'];
    }
    if ( units === MapService.FEET ) {
      sign = ' ft';
      value = value / feetValue;
    }
    if ( isNaN ( value ) ) {
      return '0' + sign;
    }
    // console.log ( '%c XXXXXX', value, sign, units );
    return this.realNumber ( value ) + sign;
  }

  calculateLineInformation ( here:any, there:any ) {
    let ret = this.calculateSlope ( here, there );
    ret.length = this.calculateLength ( here, there );
    ret.midpoint = this.calculateMidpoint ( here, there );
    ret.azimuth = this.calculateAzimuth ( here, there );
    return ret;
  }

  // calculate the length between two points
  calculateMidpoint ( here:any, there:any ) {

    var scratch = new Cesium.Cartesian3();

    var difference = Cesium.Cartesian3.subtract(here, there, scratch);
    var distance = Cesium.Cartesian3.magnitude(difference);
    var direction = Cesium.Cartesian3.normalize(difference, scratch);

    return Cesium.Cartesian3.add( there, Cesium.Cartesian3.multiplyByScalar(direction, distance * 0.5, scratch), scratch);
  }

  // calculate the length between two points
  calculateLength ( here:any, there:any ) {
    let distance = Cesium.Cartesian3.distance ( here, there );
    return distance;
  }

  // calculate slope between two points
  calculateSlope ( start:any, end:any ) {

    'use strict';
    var ellipsoid = Cesium.Ellipsoid.WGS84;
    var geoStartAndEnd = ellipsoid.cartesianArrayToCartographicArray([start, end]);
    var geoStart = geoStartAndEnd[0],
      geoEnd = geoStartAndEnd[1];

    // If the height of the start point is larger than the endpoint then the sign of the elevation change is negative
    // This also causes the slope degrees to be negative
    var slopesDown = geoStart.height > geoEnd.height;

    // Set the height of geoEnd to be the same as geoStart, and convert back to cartesian
    geoEnd.height = geoStart.height;
    var normalisedEnd = ellipsoid.cartographicToCartesian(geoEnd);

    // Store the vector parallel to surface in this
    var parallel: { x: any, y: any, z: any } = {x: '', y: '', z: ''};
    Cesium.Cartesian3.subtract(normalisedEnd, start, parallel);

    var normal: { x: any, y: any, z: any } = {x: '', y: '', z: ''};
    Cesium.Cartesian3.subtract(end, normalisedEnd, normal);

    // The result, start to end, is composed of a run of length <startToEndOnEarthSurface>
    // and a rise of <projectedToEndFromEarthSurface>, so compute those
    var parallelDistance = Math.sqrt(Math.pow(parallel.x, 2) + Math.pow(parallel.y, 2) + Math.pow(parallel.z, 2));
    var normalDistance = Math.sqrt(Math.pow(normal.x, 2) + Math.pow(normal.y, 2) + Math.pow(normal.z, 2));

    if (slopesDown) {
      normalDistance *= -1;
    }

    return {
      lengthHorizontal: Math.abs ( parallelDistance ),
      slopeVertical: Math.abs ( normalDistance ),
      slopePercent: Math.abs ( normalDistance / parallelDistance * 100 ),
      midpoint: null,
      length: null,
      azimuth: null
    };
  }

  calculateAzimuth (cartesianPointA: any, cartesianPointB: any) {
    'use strict';
    var cartographicPointA = this.mapService.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesianPointA),
      cartographicPointB = this.mapService.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesianPointB);

    var longA = cartographicPointA.longitude,
      longB = cartographicPointB.longitude,
      latA = cartographicPointA.latitude,
      latB = cartographicPointB.latitude;

    var longChange = Math.sin(longB - longA) * Math.cos(latB);
    var latChange = Math.cos(latA) * Math.sin(latB) - Math.sin(latA) * Math.cos(latB) * Math.cos(longB - longA);

    var bearingDegrees = (Math.atan2(longChange, latChange) * (180 / Math.PI));


    return (bearingDegrees + 360) % 360;
  }

  calculateCentroid (pts) {

    var first = pts[0], last = pts[pts.length-1];

    if (first.x != last.x || first.y != last.y) pts.push(first);

    var twicearea=0,
    x=0, y=0, z=-9999999999,
    nPts = pts.length,
    p1, p2, f;

    for ( var i=0, j=nPts-1 ; i<nPts ; j=i++ ) {
      p1 = pts[i]; p2 = pts[j];
      f = (p1.y - first.y) * (p2.x - first.x) - (p2.y - first.y) * (p1.x - first.x);
      twicearea += f;
      x += (p1.x + p2.x - 2 * first.x) * f;
      y += (p1.y + p2.y - 2 * first.y) * f;
      if ( p1.z > z ) { z = p1.z; }
    }
    f = twicearea * 3;
    return { x: x/f + first.x, y: y/f + first.y, z: z };
  }

  







  // END of refactoring; all the following code is older, and may or may not still be in use (future project to purge ...)

  getGeoJSON(annotation) {

    const debugStyle = 'color:red;background-color:#ccc;';

    // Note: a bit of refactoring here has been done, mostly to make it compatible with the new shape structures, however
    // a lot of the underlying structure and logic is the same. All of it needs a refactoring, it's still quite messy

    let a_name = annotation.name;
    let a_id = annotation.id;



    let featureCollection = new FeatureCollection();
    featureCollection.type = 'FeatureCollection';
    featureCollection.features = [];

    if ( annotation['shapes'] ) {


      // single pins
      if (annotation['annotationMode'] === 'poi') {

        let geometry = new Geometry();
        geometry.type = 'Point';
        geometry.coordinates = [];

        let coords = [annotation.llng, annotation.llat, annotation.lheight];
        // console.log ( '   coords (pin)', coords);

        geometry.coordinates = coords;
        let features = new Features();
        features.type = 'Feature';
        features.geometry = geometry;
        features.properties = {
          name: a_name +' [Pin]',
          id: a_id
        }
        featureCollection.features.push(features);
      }

      // multi-points
      else if (annotation['annotationMode'] === 'multiPoi') {
        for (let i = 0; i < annotation['shapes'].length; i++) {

          let shape = annotation['shapes'][i];

          shape.points.forEach(v1 => {
            let geometry = new Geometry();
            geometry.type = 'Point';
            geometry.coordinates = [];
            // console.log ( '   coords (multi-pin)', v1['coords']);
            let latLong = Cesium.Cartographic.fromCartesian(v1['coords'], Cesium.Ellipsoid.WGS84, this.tempCartographic);
            geometry.coordinates = [latLong.longitude * 180 / Math.PI, latLong.latitude * 180 / Math.PI, latLong.height];
            let features = new Features();
            features.type = 'Feature';
            features.geometry = geometry;
            features.properties = {
              name: a_name + ' ('+i+') [MultiPoint]',
              id: a_id + '_'+i,
              'clampToModel': shape['clampToModel'] ? shape['clampToModel'] : null,
              'color': shape['color'] ? shape['color'] : null,
              'lineWidth': shape['lineWidth'] ? shape['lineWidth'] : null,
            }

            // if (annotation['pointsProps'][i].findIndex(e => e['currentColor']) !== -1) {
            //   features.properties['currentColor'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentColor'])]['currentColor']
            // }

            featureCollection.features.push(features);
          });
        }

        // all other shapes
      } else {

        // for each shape
        for (let i = 0; i < annotation['shapes'].length; i++) {

          let shape = annotation['shapes'][i];

          let geometry = new Geometry();
          geometry.type = (annotation['annotationMode'] === 'line' || annotation['annotationMode'] === 'flyToLine') ? 'LineString' : 'Polygon';
          geometry.coordinates = [];
          let arr = [];

          // lines must be longer than 1 point, and all other (polygons) must be longer than 2
          if (annotation['annotationMode'] === 'line' && shape.points.length < 2) return;
          else if (annotation['annotationMode'] !== 'line' && shape.points.length < 3) return;

          // console.log ( '@@@@@@@@@@@@@@@@@', i, annotation['shapes'][i] );

          shape.points.forEach(v1 => {
            // console.log ( '   coords (shape)', v1['coords']);
            let latLong = Cesium.Cartographic.fromCartesian(v1['coords'], Cesium.Ellipsoid.WGS84, this.tempCartographic);
            arr.push([latLong.longitude * 180 / Math.PI, latLong.latitude * 180 / Math.PI, latLong.height]);
          });

          if ( arr.length > 0 ) {

            if (annotation['annotationMode'] === 'line') {
              geometry.coordinates = arr;
            } else {
              geometry.coordinates.push(arr);
            }

            let features = new Features();
            features.type = 'Feature';
            features.geometry = geometry;



            features.properties = {
              name: a_name + ' ('+i+') ['+annotation['annotationMode']+']',
              id: a_id + '_'+i,
              'clampToModel': shape['clampToModel'] ? shape['clampToModel'] : null,
              'color': shape['color'] ? shape['color'] : null,
              'lineWidth': shape['lineWidth'] ? shape['lineWidth'] : null,
              'calculations': shape['calc'] ? shape['calc'] : null,
            }

            /*
            if (annotation['pointsProps'][i].findIndex(e => e['measuredValue']) !== -1) {
              if (annotation['annotationMode'] === 'area') {
                features.properties['area'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['measuredValue'])]['measuredValue']
              } else if (annotation['annotationMode'] === 'volume') {
                features.properties['volume'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['measuredValue'])]['measuredValue']
              }
            }

            if (annotation['pointsProps'][i].findIndex(e => e['currentColor']) !== -1) {
              features.properties['currentColor'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentColor'])]['currentColor'];
            }
            if (annotation['pointsProps'][i].findIndex(e => e['currentLineWidth']) !== -1 ) {
              features.properties['currentLineWidth'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentLineWidth'])]['currentLineWidth'];
            }
            */

            featureCollection.features.push(features);
          }

        }
      }
    }
    return featureCollection;
  }


  sendFile(data, annotation, snackBar, mapComp) {
    let imageName = annotation.name + '.json';
    var xhr = new XMLHttpRequest();
    var upload = xhr.upload;
    upload.addEventListener('progress', (evt) => {
      if (evt.lengthComputable) {
        console.log(evt,data);
      }
    }, false);

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {

        if (!xhr.responseText || xhr.responseText === '') {
          snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          return;
        }
        // good response
        var res = JSON.parse(xhr.responseText);
        if (res.status && res.status === 200) {
          {
          }
        } else if (res.status && res.status < 400) {
          console.log('vasat error');
          snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          // vasat error
        } else {
          snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          console.log('all good');
        }
      }
    };
    xhr.open('POST', mapComp.fourD.V.config.host + '/api/Annotation/' + annotation.id + '/' + imageName);
    xhr.overrideMimeType('application/binary');
    xhr.setRequestHeader('Content-Type', 'application/binary')
    xhr.setRequestHeader('Authorization', 'Bearer ' + mapComp.fourD.V.token)
    let d = JSON.stringify(data);
    xhr.send(d);
  }

  // currently skiped this reading, no backward compatibility
  readCoordinatesFromFileAndPrint(annotation) {
    //if annotation is already created and is not poi then only get the json file
    if (annotation.id && annotation['annotationMode'] !== 'poi') {
      this.httpClient.get(annotation.file(annotation.name + '.json'), {responseType: 'text'})
        .pipe(
          tap(
            data => data,
            error => console.log(error)
          )
        )
        .subscribe(s => {
            let parsedData = JSON.parse(s);
            console.log(parsedData)
            if (parsedData) {
              let featureCollection: FeatureCollection = parsedData;
              annotation['points'] = [];
              annotation['pointsProps'] = [];
              if (annotation['annotationMode'] === 'line' ) {
                featureCollection.features.forEach(f => {
                  let aa = [];
                  let pp = [];
                  f.geometry.coordinates.forEach(coords => {
                    aa.push({'coords': Cesium.Cartesian3.fromDegrees(coords[0], coords[1], coords[2])});
                  });
                  pp.push({'clampToModel' : !!f.properties['clampToModel'] });
                  if(f.properties['currentColor']){
                    pp.push({'currentColor' : f.properties['currentColor'] });
                  }
                  if(f.properties['currentLineWidth']){
                    pp.push({'currentLineWidth' : f.properties['currentLineWidth'] });
                  }
                  annotation['points'].push(aa);
                  annotation['pointsProps'].push(pp);

                })
              } else if( annotation['annotationMode'] === 'multiPoi'  ){
                let aa = [];
                let pp = [];
                featureCollection.features.forEach(f => {
                  aa.push({'coords': Cesium.Cartesian3.fromDegrees(f.geometry.coordinates[0], f.geometry.coordinates[1], f.geometry.coordinates[2])});
                })
                pp.push({'clampToModel' : !!featureCollection.features[0].properties['clampToModel'] });
                if(featureCollection.features[0].properties['currentColor']){
                  pp.push({'currentColor' : featureCollection.features[0].properties['currentColor'] });
                }
                if(featureCollection.features[0].properties['currentLineWidth']){
                  pp.push({'currentLineWidth' : featureCollection.features[0].properties['currentLineWidth'] });
                }
                annotation['points'].push(aa);
                annotation['pointsProps'].push(pp);
              } else {
                featureCollection.features.forEach(f => {
                  f.geometry.coordinates.forEach(coords => {
                    let aa = [];
                    let pp = [];
                    coords.forEach(subCords => {
                      aa.push({'coords': Cesium.Cartesian3.fromDegrees(subCords[0], subCords[1], subCords[2])});
                    });
                    pp.push({'clampToModel' : !!f.properties['clampToModel'] });
                    if(f.properties['currentColor']){
                      pp.push({'currentColor' : f.properties['currentColor'] });
                    }
                    if(f.properties['currentLineWidth']){
                      pp.push({'currentLineWidth' : f.properties['currentLineWidth'] });
                    }
                    annotation['points'].push(aa);
                    annotation['pointsProps'].push(pp);
                  })
                })
                if(annotation['clipPlanes']){
                  annotation['points'].forEach(point => {
                    this.mapService.clipPlanes(point, annotation['clipPlanes']);
                  })
                }
              }
              annotation.saveObservable().subscribe();

              if ( annotation['showPermanent']) {
                console.log ( 'measure_helper.service :: readCoordinates() -> showPermanentPoints()');
                // this.showPermanentPoints(annotation, true);
              }
            }
          },
          error1 => {
            console.log(error1);
          });
    }
  }




}
